module.exports = __webpack_public_path__ + "static/media/noPhoto-large.d6749022.webp";